import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { AltitudeRangeState } from "../altitudeRangeReducer";

export const changeLowerLimitPartialReducer: IPartialReducer<AltitudeRangeState> = (state, action) => {
    return {
        ...state,
        lowerLimit: action.lowerLimit,
    };
};
